import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m5.265 8.327 1.757 2.476a.75.75 0 0 0 .602.33.758.758 0 0 0 .622-.294l5.624-7.06",
  stroke: "#0F6378",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.576 1a1.08 1.08 0 0 0-.761.312c-.202.2-.315.472-.315.755v6.4c0 3.422 5.187 7.231 6.95 8.362a1.066 1.066 0 0 0 1.158 0c1.763-1.131 6.95-4.94 6.95-8.362v-6.4a1.058 1.058 0 0 0-.314-.755 1.077 1.077 0 0 0-.76-.312H2.575Z",
  stroke: "#0F6378",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }